export const CRISIS_JOIN_SIMULATION_START = "CRISIS_JOIN_SIMULATION/CRISIS_JOIN_SIMULATION_START";
export const CRISIS_JOIN_SIMULATION_FAIL = "CRISIS_JOIN_SIMULATION/CRISIS_JOIN_SIMULATION_FAILED";
export const CRISIS_JOIN_SIMULATION_SUCCESS = "CRISIS_JOIN_SIMULATION/CRISIS_JOIN_SIMULATION_SUCCESS";
